import React from 'react'
import { useActions, useValues } from 'kea'
import { useSelector } from 'react-redux'

import I18n from 'lib/i18n'
import PhoneNumberInput from 'lib/forms/phone-number'
import railsContext from 'lib/selectors/rails-context'

import sceneLogic from '~/scenes/pages/request/logic'

const Phone = () => {
  const { setPhone } = useActions(sceneLogic)
  const { phone, errors } = useValues(sceneLogic)
  const { sessionCountry } = useSelector(railsContext)

  return (
    <div className={`form-element full-width${errors.phone ? ' has-errors' : ''}`}>
      <label htmlFor='phone-input' className='block'>
        {I18n.t('react.request.request.phone')}
      </label>
      <PhoneNumberInput id='phone-input' value={phone} defaultCountry={sessionCountry} onChange={setPhone} />
      {errors.phone && <div className='simple-error'>{errors.phone}</div>}
    </div>
  )
}

export default Phone
